import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VehicleNavigationComponent } from 'app/shared/components/vehicle-navigation/vehicle-navigation.component';
import { CellRendererParams } from 'app/shared/components/smart-grid/core/interfaces/cell-renderer.interface';

/** Resolve a dot-path from a row, or the row itself when no path is given. */
function resolvePath(obj: unknown, path?: string): any {
  if (!path) return obj;
  return path.split('.').reduce<any>((acc, key) => acc?.[key], obj);
}

/**
 * SmartGrid cell renderer that navigates to a vehicle master via
 * {@link VehicleNavigationComponent}. The vehicle is the row itself, or a nested
 * object addressed by `cellRendererParams.dataPath`.
 */
@Component({
  selector: 'app-vehicle-nav-cell-renderer',
  standalone: true,
  imports: [CommonModule, VehicleNavigationComponent],
  template: `
    @if (vehicle(); as v) {
      <app-vehicle-navigation
        [vehicle]="v"
        displayMode="both"
        [showIcon]="true"
        interactionMode="icon-only"
        [openInNewTab]="true"
      />
    } @else {
      <span class="text-gray-400">—</span>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VehicleNavCellRendererComponent {
  readonly params = input<CellRendererParams<any>>();

  readonly vehicle = computed(() =>
    resolvePath(this.params()?.data, this.params()?.colDef?.cellRendererParams?.dataPath),
  );
}
